"use strict";


const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

// // load font via webpack asset/resource
// require("src/tokens/index.css");


// see https://inclusive-components.design/tooltips-toggletips/
// see https://zoebijl.github.io/apg-tooltip/


class Tooltip extends HTMLElement {
    constructor(template) {
        super(template);

        this.root = this.attachShadow({ mode: "open" });

        const content = template ? template.content.cloneNode(true) : baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.tooltipContent = this.root.querySelector(".swiftref-tooltip");

    }



    connectedCallback() {
        if (this.innerHTML) {

            const icon = document.createElement("swiftref-icon");
            icon.setAttribute("kind", this.getAttribute("kind"));
            const size = this.getAttribute("size");
            icon.setAttribute("size", size);

            this.tooltipContent.innerHTML = this.innerHTML;
            this.tooltipContent.style.left = "-9px";
            this.root.appendChild(icon);

            icon.addEventListener("mouseenter", function () {
                const iconRect = icon.getBoundingClientRect();
                this.tooltipContent.classList.add("active");
                this.tooltipContent.style.bottom = "unset";
                this.tooltipContent.style.top = "unset";
                delete this.tooltipContent.style.top;
                delete this.tooltipContent.style.bottom;
                this.tooltipContent.classList.remove("bottom");

                const clientRect = this.tooltipContent.getBoundingClientRect();
                if ((clientRect.left + clientRect.width) > window.innerWidth) {
                    const offsetWidth = clientRect.width - 30;
                    this.tooltipContent.style.left = "-" + offsetWidth+"px";
                    this.tooltipContent.style.setProperty('--arrow-offset', (offsetWidth + 10) +"px")
                } else {
                    this.tooltipContent.style.left = "-9px";
                    this.tooltipContent.style.setProperty('--arrow-offset', 20+"px");
                }

                // there is space above the tooltip
                if (clientRect.height < clientRect.top) {
                    this.tooltipContent.style.bottom = (iconRect.height + 20) + "px";
                } else {
                    // if there is space above the tooltip, move it down
                    // this.tooltipContent.style.bottom = "unset";
                    this.tooltipContent.style.top = "26px";
                    this.tooltipContent.classList.add("bottom");
                }

            }.bind(this));
            icon.addEventListener("mouseleave", function () {
                this.tooltipContent.classList.remove("active");
                this.tooltipContent.style.left = "-9px";
                this.tooltipContent.style.setProperty('--arrow-offset', 20+"px");
            }.bind(this));

            icon.addEventListener("touchend", function () {
                this.tooltipContent.classList.toggle("active");
            }.bind(this));

            setTimeout(function () {
                this.innerHTML = "";
            }.bind(this), 1000)
            // this.removeChild(this.root.querySelector("swiftref-tooltip"));
        }
    }

}

window.customElements.define("swiftref-tooltip", Tooltip);

module.exports = Tooltip;
